<div class="cameraViewWrapper">
  <div class="fusus-camera-event-row">
    <div class="fusus-camera-event-col-6 fusus-camera-event-p-3 video-wrapper">
      <sn-audit-camera-stream-view
        *ngIf="camera && !isLoading"
        [camera]="camera"
        [alwaysOn]="true"
      ></sn-audit-camera-stream-view>
      <div class="loadingWrapper" *ngIf="!camera && isLoading">
        <mat-progress-spinner
          mode="indeterminate"
          color="accent"
          diameter="48"
        ></mat-progress-spinner>
      </div>
    </div>
    <div class="fusus-camera-event-col-6 fusus-camera-event-p-3">
      <div class="fusus-camera-event-col event-list-wrapper">
        <sn-camera-events-list *ngIf="camera" [camera]="camera"></sn-camera-events-list>
      </div>
    </div>
  </div>
  <br />
  <div class="fusus-camera-event-row">
    <div class="fusus-camera-event-col-12">
      <div class="fusus-camera-event-col fusus-camera-event-p-3 ">
        <sn-google-map
          *ngIf="camera?.geometry; else noLocation"
          zoom="17"
          [center]="camera.geometry.coordinates"
          (mapInit)="onMapInit($event)"
        >
        </sn-google-map>
        <ng-template #noLocation>
          <div>
            <h3 class="header-text-wrap">NO Location Available</h3>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
